import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import DownloadIcon from "@mui/icons-material/Download";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  download_notice_insert_view_log_api,
  get_unseen_notices,
  show_all_notice_api,
} from "../api/Users";
import { TablePagination } from "@mui/material";
import { toast } from "react-toastify";

const ViewNotices = ({ userData }) => {
  const [modal, setModal] = useState(false);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [loading, setLoading] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleUpdateClick = (row) => {
    setSelectedRow(row);
    setModal(true);
  };

  const handleCloseModal = () => {
    setModal(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setIsLoading(true);
    show_all_notice_api()
      .then((response) => {
        if (response.status == "success") {
          setFilteredData(response.data.result);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching new notices:", error);
      });
  }, []);

  const handleDownload = (row) => {
    console.log(row);
    if (!row || !row.attachment_path) {
      console.error("Attachment path is missing.");
      return;
    }

    const currentDate = new Date()
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");

    const path = row.attachment_path;
    const filename = path.split("/").pop();

    const data = {
      notice_id: row.id,
      view_date: currentDate,
      filePath: row.attachment_path,
      fileName: filename,
    };
    download_notice_insert_view_log_api(data)
      .then((response) => {
        if (response.status == "success") {
          toast.success("Notice Downloaded");
        }
      })
      .catch((error) => {
        console.error("Error fetching new notices:", error);
      });
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <div className="row my-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("All Notices")}</h5>

          <div className="Table mb-2">
            <TableContainer
              component={Paper}
              style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
              className="my-4"
            >
              <Table sx={{ minWidth: 800 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">{t("Sr. No.")}</TableCell>
                    <TableCell align="left">{t("Notice")}</TableCell>
                    <TableCell align="left">{t("Issue Date")}</TableCell>
                    {/* <TableCell align="left">{t("Expiry Date")}</TableCell> */}
                    <TableCell align="center">{t("Download")}</TableCell>
                  </TableRow>
                </TableHead>
                {!isLoading && filteredData && filteredData.length > 0 && (
                  <TableBody style={{ color: "white" }}>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row" align="center">
                            {index + 1}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.notice_text}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {new Date(row.start_date).toLocaleDateString(
                              "en-GB"
                            )}
                          </TableCell>
                          {/* <TableCell component="th" scope="row">
                            {new Date(row.expiry_date).toLocaleDateString(
                              "en-GB"
                            )}
                          </TableCell> */}

                          <TableCell
                            align="center"
                            className="d-flex justify-content-center"
                          >
                            <button
                              className="btn btn-primary mx-2"
                              onClick={() => handleUpdateClick(row)}
                            >
                              View
                            </button>
                            <button
                              className="btn btn-success"
                              onClick={() => handleDownload(row)}
                            >
                              Download
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                )}
                {!isLoading && (!filteredData || filteredData.length === 0) && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={7}>
                        <h4>
                          <i>{t("No data available")}</i>
                        </h4>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
        {selectedRow && (
          <Modal
            show={modal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{
              top: "10vh",
              left: "25vw",
              height: "80vh",
              maxWidth: "50vw",
              width: "100%",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              border: "none",
            }}
            className="d-flex justify-content-center"
          >
            {/* <Typography variant="h6" className="text-center">
            {t("Notice")}
          </Typography> */}
            <div
              className="rounded"
              style={{
                position: "absolute",
                top: "250px",
                left: "52%",
                transform: "translate(-50%, -50%)",
                border: "1px solid lightgray",
              }}
            >
              <h4
                className="text-center fw-bold py-3"
                style={{
                  margin: 0,
                  width: "750px",
                  borderBottom: "0.5px solid lightgray",
                }}
              >
                HEAD OFFICE OF SCHOOL MANAGEMENT SC & ST DEPARTMENT - ODISHA
                GOVT
              </h4>
              <h3
                className="text-center my-4"
                style={{ marginBottom: "0px", textDecoration: "underline" }}
              >
                NOTICE
              </h3>
              <div className="col-12 d-flex justify-content-between">
                <h4 className="mx-4">Issued by: HEAD OFFICE</h4>
                <h4 className="mx-4">
                  Date:
                  {new Date(selectedRow.expiry_date).toLocaleDateString(
                    "en-GB"
                  )}
                </h4>
              </div>
              <h3
                className="text-center my-4"
                style={{ marginBottom: "0px", textDecoration: "underline" }}
              >
                {selectedRow.notice_text}
              </h3>
              <p className="col-12 p-5 pt-3 fs-6">
                It is hereby notified that a March Past Competition will be held
                on 15th August, 2024 as part of Hostel Week 2024-25. All the
                Departments, Girls’ and Boys’ Hostel interested in participating
                the event must submit their names to the President, SCSTH by
                WhatsApp No. XXXXXX45 on or before 2nd of August 2024 (Before
                5:00 P.M)
              </p>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCloseModal}
              style={{
                position: "absolute",
                top: 0,
                left: 350,
                background: "none",
                border: "none",
                fontSize: 24,
                cursor: "pointer",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ViewNotices;
